<div
  class="mr-paragraph"
  [attr.data-align]="block.align || 'center'"
  [innerHTML]="t(block.text) | markdownHtml"
></div>
